/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Accordion, Stack, Table } from '@mantine/core'
import { useState } from 'react'
import Amount from '../transaction/Amount'
import NoDataAlert from '../../../../client/js/components/NoDataAlert'
import CustomerReportPeriod from './CustomerReportPeriod'

export type CustomerReportProps = {
  data: TransactionReportData;
  defaultPeriod?: string;
}

function CustomerReport (props: CustomerReportProps) {
  const { data, defaultPeriod } = props
  const [activePeriod, setActivePeriod] = useState<string | null>(defaultPeriod)
  return (
    <Stack>
      {data.periods.length === 0
        ? <NoDataAlert />
        : <Accordion
          transitionDuration={0}
          onChange={setActivePeriod}
          value={data.periods.length === 1 ? data.periods[0].label : activePeriod}
        >
          {data.periods.map((period) => (
            <CustomerReportPeriod
              key={period.label}
              data={period}
            />
          ))}
        </Accordion>}

      {data.periods.length > 1
        ? <Table bg="gray.0">
          <Table.Tfoot>
            <Table.Tr>
              <Table.Th colSpan={2} />
              <Table.Th
                ta="end"
                w={120}
              >
                <FormattedMessage
                  id="revenues_excluding_taxes"
                  defaultMessage="Revenus HT"
                />
              </Table.Th>
              <Table.Th
                ta="end"
                w={120}
              >
                <FormattedMessage
                  id="expenses_excluding_taxes"
                  defaultMessage="Dépenses HT"
                />
              </Table.Th>
              <Table.Th
                ta="end"
                w={120}
              >
                <FormattedMessage
                  id="vat"
                  defaultMessage="TVA"
                />
              </Table.Th>
              <Table.Th
                ta="end"
                w={120}
              >
                <FormattedMessage
                  id="cps"
                  defaultMessage="CPS"
                />
              </Table.Th>
            </Table.Tr>
            <Table.Tr>
              <Table.Th colSpan={2}>
                <FormattedMessage
                  id="total"
                  defaultMessage="Total"
                />
              </Table.Th>
              <Table.Td ta="end">
                <Amount value={data.revenues} />
              </Table.Td>
              <Table.Td ta="end">
                <Amount value={data.expenses} />
              </Table.Td>
              <Table.Td ta="end">
                <Amount value={data.vat} />
              </Table.Td>
              <Table.Td ta="end">
                <Amount value={data.cps} />
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th colSpan={2}>
                <FormattedMessage
                  id="balance_excluding_taxes"
                  defaultMessage="Solde HT"
                />
              </Table.Th>
              <Table.Td ta="end">
                <Amount value={data.balance} colored />
              </Table.Td>
              <Table.Td colSpan={3}></Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th colSpan={2}>
                <FormattedMessage
                  id="balance_including_taxes"
                  defaultMessage="Solde TTC"
                />
              </Table.Th>
              <Table.Td ta="end">
                <Amount value={data.balanceWithTax} colored />
              </Table.Td>
              <Table.Td colSpan={3}></Table.Td>
            </Table.Tr>
          </Table.Tfoot>
        </Table>
        : null}
    </Stack>
  )
}

export default CustomerReport
